import {
  Skeleton,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  useTheme,
} from '@mui/material';

export default function ProfileTreatmentsTableSkeleton() {
  const theme = useTheme();

  const BodyRow = (
    <TableRow>
      <TableCell align="left">
        <Skeleton variant="rounded" height="22px" width="130px" />
      </TableCell>
      <TableCell align="left">
        <Skeleton variant="rounded" height="22px" width="150px" />
      </TableCell>
      <TableCell align="left">
        <Skeleton variant="rounded" height="22px" width="110px" />
      </TableCell>
      <TableCell align="left">
        <Skeleton variant="rounded" height="22px" width="100px" />
      </TableCell>
      <TableCell align="left">
        <Skeleton variant="circular" height="22px" width="22px" />
      </TableCell>
      <TableCell align="left">
        <Skeleton variant="rounded" height="22px" width="70px" />
      </TableCell>
    </TableRow>
  );

  return (
    <>
      <TableContainer
        sx={{ height: 1, display: 'flex', flexDirection: 'column' }}
      >
        <Table>
          <TableHead>
            <TableRow>
              <TableCell
                align="left"
                sx={{ backgroundColor: theme.palette.grey[300] }}
              >
                <Skeleton variant="rounded" height="24px" width="50px" />
              </TableCell>
              <TableCell
                align="left"
                sx={{ backgroundColor: theme.palette.grey[300] }}
              >
                <Skeleton variant="rounded" height="24px" width="40px" />
              </TableCell>
              <TableCell
                align="left"
                sx={{ backgroundColor: theme.palette.grey[300] }}
              >
                <Skeleton variant="rounded" height="24px" width="80px" />
              </TableCell>
              <TableCell
                align="left"
                sx={{ backgroundColor: theme.palette.grey[300] }}
              >
                <Skeleton variant="rounded" height="24px" width="40px" />
              </TableCell>
              <TableCell
                align="left"
                sx={{ backgroundColor: theme.palette.grey[300] }}
              >
                <Skeleton variant="rounded" height="24px" width="90px" />
              </TableCell>
              <TableCell
                align="left"
                sx={{ backgroundColor: theme.palette.grey[300] }}
              >
                <Skeleton variant="rounded" height="24px" width="70px" />
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {BodyRow}
            {BodyRow}
            {BodyRow}
            {BodyRow}
            {BodyRow}
            {BodyRow}
          </TableBody>
        </Table>
      </TableContainer>
      <Skeleton variant="rectangular" height="1px" width="100%" />
      <Stack
        sx={{
          minHeight: 52,
          pr: 1,
          flexDirection: 'row',
          gap: 3,
          justifyContent: 'flex-end',
          alignItems: 'center',
        }}
      >
        <Skeleton variant="rounded" height="22px" width="170px" />
        <Skeleton variant="rounded" height="22px" width="50px" />
        <Stack sx={{ gap: 1, flexDirection: 'row' }}>
          <Skeleton variant="circular" height="40px" width="40px" />
          <Skeleton variant="circular" height="40px" width="40px" />
        </Stack>
      </Stack>
    </>
  );
}
